// Chrome fires this when a resize callback changes layout in the same frame.
// The derivatives table does that on open. It is not a crash; the dev overlay
// treats the window error as one and covers the page. Capture phase runs
// before the overlay's listener.
window.addEventListener(
  "error",
  (event) => {
    if (typeof event.message === "string" && event.message.includes("ResizeObserver loop")) {
      event.stopImmediatePropagation();
    }
  },
  true
);
